import { combineReducers } from "redux";
import userManagerReducer from "../modules/UserManager/redux/userManagerReducer";
import departEmailsReducer from "../modules/DepartmentEmails/redux/departEmailsReducer";
import departmentReducer from "../modules/ActivityTypes/redux/activityTypesReducer";
import clientManagerReducer from "../modules/ClientsManager/redux/clientManagerReducer";
import salesReducer from "../modules/Sales/redux/salesReducer";
import salesGraphReducer from "../modules/Sales/redux/graphReducer";
import imsReducer from "../modules/IMS/redux/reducer";
import projectReducer from "../modules/Projects/redux/reducer";
import authReducer from "../modules/login/redux/authReducer";
import productionReducer from "../modules/Production/redux/productionReducer";
import secondLevelReducer from "../modules/Production/redux/secondLevelReducer";
import thirdLevelReducer from "../modules/Production/redux/thirdLevelReducer";
import fourthLevelReducer from "../modules/Production/redux/fourthLevelReducer";
import salesSecondLevelReducer from "../modules/Sales/redux/salesSecondLevelReducer";
import projectStatusReducer from "../modules/ProjectStatuses/redux/projectStatusesReducer";
import projectsSetupReducer from "../modules/ProjectSetup/redux/projectsSetupReducer";
import revisionStatusReducer from "../modules/RevisionStatuses/redux/projectStatusesReducer";
import docStatusReducer from "../modules/DocumentStatuses/redux/docStatusesReducer";
import documentFieldReducer from "../modules/DefaultDocumentFields/redux/documentFieldReducer";
import docTypesReducer from "../modules/DocumentsTypesManager/redux/docTypesReducer";
import documentControlReducer from "../modules/DocumentControl/redux/documentControlReducer";
import imsRevisionsReducer from "../modules/IMS/tableSection/revisions/redux/revisionsReducer";
import imsDistributionReducer from "../modules/IMS/tableSection/distributionTable/redux/distributionReducer";
import projectRevisionsReducer from "../modules/Projects/tableSection/revisions/redux/revisionsReducer";
import projectDistributionReducer from "../modules/Projects/tableSection/distributionTable/redux/distributionReducer";
import notificationsReducer from "../modules/container/notifications/notificationsRedux/notificationReducer";

export default combineReducers({
  documentControlReducer,
  revisionStatusReducer,
  docTypesReducer,
  documentFieldReducer,
  projectStatusReducer,
  userManagerReducer,
  departEmailsReducer,
  departmentReducer,
  clientManagerReducer,
  salesReducer,
  imsReducer,
  authReducer,
  productionReducer,
  secondLevelReducer,
  thirdLevelReducer,
  fourthLevelReducer,
  salesGraphReducer,
  salesSecondLevelReducer,
  projectsSetupReducer,
  docStatusReducer,
  imsRevisionsReducer,
  imsDistributionReducer,
  projectReducer,
  projectRevisionsReducer,
  projectDistributionReducer,
  notificationsReducer,
});
